import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

// Versioning
import { VersionCheckService } from './version-check.service';

// HTTP and interceptors
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { StingrayTokenInterceptor } from './interceptors/stingray-api-token.interceptor';
import { OctopusApiTokenInterceptor } from './interceptors/octopus-api-token.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

// Routing
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { RouteReusableStrategy } from './route-reusable-strategy';

// Translations
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { I18nService } from './i18n.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './translation-providers/paginator-i18n';

// Authentication and subscriptions
import { StingrayAuthenticationService } from './authentication/stingray-authentication.service';

// Api modules
import { ApiModule as OctopusApiModule } from '@app/core/octopus-api/api.module';
import { ApiModule as StingrayApiModule } from '@app/core/stingray-api/api.module';
import { provideApiConfiguration } from '@app/core/agent-api/api-configuration';

// Layout
import { MaterialModule } from '@app/material.module';


// Shared
import { SharedModule } from '@app/shared/shared.module';

// Toaster
import { ToasterComponent } from './toaster/toaster.component';
import { ToasterService } from './toaster/toaster.service';
import { GoogleAnalyticsService } from './analytics/google-analytics.service';
import { Angulartics2Module } from 'angulartics2';
import { OctopusApiAuthenticationService } from './authentication/octopus-api-authentication.service';
import { PortalService } from './portal/portal.service';
import { environment } from '@env/environment';


@NgModule({ imports: [CommonModule,
        TranslateModule,
        RouterModule,
        MaterialModule,
        SharedModule,
        OctopusApiModule.forRoot({ rootUrl: environment.octopusApiEndpoint }),
        StingrayApiModule.forRoot({ rootUrl: environment.stingrayApiEndpoint }),
        Angulartics2Module,
        ToasterComponent], providers: [
        VersionCheckService,
        StingrayAuthenticationService,
        OctopusApiAuthenticationService,
        PortalService,
        I18nService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: StingrayTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: OctopusApiTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: RouteReuseStrategy, useClass: RouteReusableStrategy
        },
        ToasterService,
        {
            provide: MatPaginatorIntl, deps: [TranslateService],
            useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
        },
        GoogleAnalyticsService,
        provideApiConfiguration(environment.agentApiBaseUrl),
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}
